import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthProvider";
import { Redirect, Route, useLocation } from "react-router-dom";
import { SIGNUP_REASONS, SIGNUP_SURFACES } from "../../analytics";

const PrivateRoute = props => {
  const { user } = useContext(AuthContext);
  const location = useLocation();

  return (
    <Route {...props}>
      {user.role === "private" ? (
        props.component ? (
          <props.component />
        ) : (
          props.children
        )
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: {
              from: location,
              background: location,
              signupPrompt: {
                reason: SIGNUP_REASONS.PROTECTED_ROUTE,
                surface: SIGNUP_SURFACES.ROUTE_GUARD
              }
            }
          }}
        />
      )}
    </Route>
  );
};

export default PrivateRoute;
